import request from '../request';
// 获取未读消息数量
const getMessageCount = (data) => {
    return request.post('/api/wx/auth/messages/queryMessAgesCount')
}
// 消息设置全部已读
const readAllMessage = (data) => {
    return request.post('/api/wx/auth/messages/read', data)
}
// 阅读消息
const readMessage = (data) => {
    return request.post('/api/wx/auth/messages/readMessage', data)
}
// 清除消息
const clearMessage = (data) => {
    return request.post('/api/wx/auth/messages/clearMessAges', data)
}
// 删除消息
const delMessage = (data) => {
    return request.post('/api/wx/auth/messages/deteleMessAges', data)
}
// 获取消息列表
const getMessages = (data) => {
    return request.post('/api/wx/auth/messages/queryMessAges', data)
}
export default {
    getMessageCount,
    readAllMessage,
    readMessage,
    clearMessage,
    getMessages,
    delMessage
};